import { makeStyles } from '@mui/styles'
import { CONDUCCO_LOGO_PATHS } from 'constants/conduco-paths'
import { useAuth } from 'contexts/auth'
import { useLocation } from 'react-router-dom'
import { getRGBA } from 'utils/color'

const useStyles = makeStyles({
  logo: {
    height: '2rem',
  },

  text: {
    margin: 0,
    padding: 0,
    fontFamily: 'Sora',
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: '2rem',
    color: getRGBA('#0F0F1E', 0.6),
  },
})

const ThemeBaseLogo = () => {
  const classes = useStyles()
  const { user } = useAuth()
  const location = useLocation()

  let haveLogo = !!user?.theme?.baseLogo

  if ((user && user.isAdmin) || CONDUCCO_LOGO_PATHS.includes(location.pathname)) {
    return (
      <img
        className={classes.logo}
        src='/default/logo.svg'
        alt='company logo'
      />
    )
  }

  if (haveLogo) {
    return (
      <img
        className={classes.logo}
        src={user?.theme?.baseLogo}
        alt='company logo'
      />
    )
  }

  return <p className={classes.text}>{user?.organization?.name}</p>
}

export default ThemeBaseLogo
